// import DocumentToHtml from "src/helpers/renderers/documentToHtml";
import { RecipeFieldTypes } from "src/types/contentfulTypes";

// Contentful text renderer
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { documentToHtmlOptions } from "src/helpers/renderers/documentToHtmlOptions";

import "./RecipeIngredients.scss";

interface RecipeIngredientsProps
  extends Pick<RecipeFieldTypes, "ingredients"> {}

const RecipeIngredients = ({ ingredients }: RecipeIngredientsProps) => {
  return (
    <div className="recipe-ingredients shadow--light">
      <h2 className="recipe-ingredients__title">Ingredients</h2>
      {/* <DocumentToHtml document={ingredients}></DocumentToHtml> */}

      {documentToReactComponents(ingredients, documentToHtmlOptions)}
    </div>
  );
};

export default RecipeIngredients;
